import { Box } from "@mui/system";
import { TabPanelProps, TabsProps } from ".";
import ReplayIcon from "@mui/icons-material/Replay";
import {
	IconButton,
	Tab,
	Tabs as BaseTabs,
	Typography,
} from "@mui/material";

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ pt: 2, pb: 2 }}>
					<Typography component={"div"}>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default function sTabs({
	value,
	tabs,
	onChange,
	onRefresh,
	showRefresh,
}: TabsProps) {
	return (
		<div style={{ position: "relative" }}>
			{showRefresh && (
				// Sits in the flow just above the strip. It used to be absolutely
				// positioned over the strip's top-right, which is exactly where the
				// scroll-right arrow lands once the tabs overflow — the two
				// overlapped. A negative offset can't work either: the banner leaves
				// only 20px of clearance and its action button occupies the same
				// right edge.
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						mb: 0.25,
					}}
				>
					<IconButton
						size="small"
						aria-label="refresh"
						onClick={() => onRefresh?.()}
						sx={{ cursor: "pointer", mr: "12px" }}
					>
						<ReplayIcon color="primary" />
					</IconButton>
				</Box>
			)}
			<Box
				sx={{
					borderBottom: 1,
					borderColor: "divider",
					"& .MuiButtonBase-root": {
						padding: "6px 12px",
						minWidth: "unset",
					},
				}}
			>
				<BaseTabs
					value={value}
					variant="scrollable"
					aria-label="basic tabs example"
					onChange={(_e, tab) => onChange(tab)}
					// Stock MUI scroll arrows, deliberately left alone. Once the
					// tabs overflow, MUI keeps the unusable arrow in the layout and
					// merely fades it (opacity: 0), so there is a small permanent
					// gap before the first tab. That gap is the point: collapsing it
					// makes the whole strip jump sideways every time scrolling
					// toggles the arrow on and off.
				>
					{tabs.map(({ label, icon }: any, index: any) => (
						<Tab
							key={index}
							label={label}
							icon={icon || null}
							iconPosition="start" 
							sx={{ textTransform: "capitalize" }}
							{...a11yProps(index)}
						/>
					))}
				</BaseTabs>
			</Box>

			{tabs.map(({ element }: any, index: number) => (
				<TabPanel value={value} index={index} key={index}>
					{element}
				</TabPanel>
			))}
		</div>
	);
}
